import { View } from 'react-native';
import TextLato from '@photosi/rn-components/text/text-lato/TextLato';
import { style } from './PickerGooglePhoto.style';
import { observer } from 'mobx-react-lite';
import { BannerLoggedUser } from './BannerLoggedUser';
import { ICON_NAMES } from '@photosi/rn-components/icon/icon.helper';
import { Icon } from '@photosi/rn-components/icon/Icon';
import { SecondaryButton } from '@photosi/rn-components/buttons/secondary-button/SecondaryButton';
import { TestIDs } from 'src/constants/testIDs.constants';
import { modalTestID } from 'src/helpers/testIDs.helper';
import { BUTTON_TEXT_POSITIONS } from '@photosi/rn-components/buttons/button/Button.types.constants';
import { PrimaryButton } from '@photosi/rn-components/buttons/primary-button/PrimaryButton';
import { FocusGroups } from '@photosi/rn-components/focus-provider/FocusProvider.constants';
import { usePickerGooglePhotoLogic } from './PickerGooglePhoto.logic';
import { PickerGooglePhotoErrors } from '../../../picker-google-photo/picker-google-photo-errors/PickerGooglePhotoErrors';

export const PickerGooglePhoto = observer(() => {
  const {
    i18n,
    isDesktop,
    isUserLogged,
    hasGivenAccessToPhoto,
    handleChoosePhoto,
    handleLogin,
    email,
    profilePic,
    handleLogout,
  } = usePickerGooglePhotoLogic();

  return (
    <View style={style.container}>
      <View style={style.modalContainer}>
        <View style={style.wrapperContainer}>
          <View style={[style.content, !isDesktop && !isUserLogged && { gap: 40 }]}>
            <View style={style.googlePhotoIcon}>
              <Icon name={ICON_NAMES.GooglePhoto} />
            </View>
            <View style={style.text}>
              <TextLato style={style.title}>
                {isUserLogged
                  ? i18n.t('modal-picker-google-photo:title-logged')
                  : i18n.t('modal-picker-google-photo:title-upload')}
              </TextLato>
              <TextLato style={style.description}>
                {isUserLogged
                  ? i18n.t('modal-picker-google-photo:description-logged')
                  : i18n.t('modal-picker-google-photo:description-upload')}
              </TextLato>
            </View>
            {isUserLogged ? (
              <View>
                <PrimaryButton
                  style={[style.buttonPrimary, !hasGivenAccessToPhoto && style.buttonPrimaryDisabled]}
                  onPress={handleChoosePhoto}
                  disabled={!hasGivenAccessToPhoto}
                  text={i18n.t('modal-picker-google-photo:choose-photo')}
                  textStyle={[style.buttonPrimaryText, !hasGivenAccessToPhoto && style.buttonPrimaryTextDisabled]}
                  testID={modalTestID(TestIDs.CHOOSE_PHOTO, TestIDs.CHOOSE_GOOGLE_PHOTO)}
                  focusId={modalTestID(TestIDs.CHOOSE_PHOTO, TestIDs.CHOOSE_GOOGLE_PHOTO)}
                  focusOrder={0}
                  focusGroup={FocusGroups.MODAL}
                />
              </View>
            ) : (
              <View style={{ paddingTop: 16 }}>
                <SecondaryButton
                  style={style.buttonSecondary}
                  onPress={handleLogin}
                  testID={modalTestID(TestIDs.CHOOSE_PHOTO, TestIDs.GOOGLE_PHOTO_LOGIN)}
                  focusId={modalTestID(TestIDs.CHOOSE_PHOTO, TestIDs.GOOGLE_PHOTO_LOGIN)}
                  focusOrder={0}
                  focusGroup={FocusGroups.MODAL}
                  text={i18n.t('modal-picker-google-photo:login')}
                  textPosition={BUTTON_TEXT_POSITIONS.RIGHT}
                  textStyle={style.buttonSecondaryText}
                  accessible={true}
                  accessibilityLabel={i18n.t('modal-picker-google-photo:login')}
                  accessibilityRole="button"
                >
                  {() => (
                    <View style={style.googlePhotoIconSmall}>
                      <Icon name={ICON_NAMES.GooglePhoto} />
                    </View>
                  )}
                </SecondaryButton>
              </View>
            )}
            <PickerGooglePhotoErrors />

            {isUserLogged && !!email && (
              <View style={{ paddingTop: 8, width: '100%' }}>
                <BannerLoggedUser profilePic={profilePic} email={email} handleLogout={handleLogout} />
              </View>
            )}
          </View>
        </View>
      </View>
    </View>
  );
});

PickerGooglePhoto.displayName = 'PickerGooglePhotos';
